import { Box } from '@mui/material';
import { UploadSimple } from '@phosphor-icons/react';

import { INode } from '../../Context/FormBuilderContext';

interface ImageWidgetProps {
  node: INode;
}

export function ImageWidget({ node }: ImageWidgetProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        height: '100%',
        width: '100%',
        backgroundColor: "transparent",
        borderRadius: node.data.styles.borderRadius ? node.data.styles.borderRadius : 4
      }}
    >
      {node.data?.url ? (
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={node.data?.url}
            alt="Uploaded image"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: node.data.styles.borderRadius ? node.data.styles.borderRadius : 4
            }}
          />
        </Box>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            width: '100%',
            height: '100%',
            border: '1px dashed #98A2B3',
            borderRadius: node.data.styles.borderRadius ? node.data.styles.borderRadius : 4,
            color: '#475467',
          }}
        >
          <UploadSimple size={20} />
          <p style={{ fontSize: '14px', fontWeight: '400' }}>
            No image uploaded
          </p>
        </div>
      )}
    </div>
  );
}
